import { Link, useLocation } from "react-router-dom";
import { readerGuideByPath } from "../data/readerGuides20261006";
import { getRoboticsResearchEnhancement } from "../data/roboticsResearchEnhancements";

export default function RoboticsResearchUpdate() {
  const location = useLocation();
  if (readerGuideByPath[location.pathname.replace(/\/$/, "")]) return null;
  const update = getRoboticsResearchEnhancement(location.pathname);
  if (!update) return null;
  const locale = location.pathname.split("/")[1];
  const labels = {
    "zh-cn": { status: "资料核查", reviewed: "核查日期", context: "来源中的信息", limitations: "证据的局限", related: "TechniaHQRobot 相关页面", sources: "资料来源", accessed: "访问日期" },
    ja: { status: "資料の確認", reviewed: "確認日", context: "出典に記載された情報", limitations: "証拠の限界", related: "TechniaHQRobotの関連ページ", sources: "出典", accessed: "参照日" },
  }[locale];
  const publicationLabels = {
    "zh-cn": {
      "Official company website, continuously maintained": "持续维护的公司官网",
      "Publication date not stated": "未注明发布日期",
      "2026 event website": "2026年活动网站",
      "Official event website": "活动官方网站",
      "Official federation website": "联合会官方网站",
      "Official product overview": "官方产品介绍",
      "Official application page, continuously maintained": "持续维护的官方应用介绍页",
      "Official product announcement": "官方产品公告",
      "Official model page, continuously maintained": "持续维护的官方模型页面",
      "Jazzy documentation, continuously maintained": "持续维护的 Jazzy 文档",
    },
    ja: {
      "Jazzy documentation, continuously maintained": "継続更新されるJazzyドキュメント",
      "Documentation, continuously maintained": "継続更新されるドキュメント",
      "Official product website, continuously maintained": "継続更新される公式製品サイト",
      "Official product page": "公式製品ページ",
    },
  }[locale] || {};

  return (
    <section className="site-shell pb-12 sm:pb-16" data-robotics-research-update>
      <div className="rounded-[2rem] border border-blue-100 bg-white p-5 shadow-[0_24px_80px_rgba(15,23,42,0.07)] sm:p-8">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-blue-700 px-3 py-1 text-xs font-black uppercase tracking-[0.14em] text-white">{labels?.status || update.statusLabel}</span>
          <span className="rounded-full bg-neutral-100 px-3 py-1 text-xs font-bold text-neutral-600">{labels?.reviewed || "Reviewed"} {update.reviewed}</span>
        </div>

        <h2 className="mt-5 text-2xl font-black tracking-tight text-neutral-950 sm:text-3xl">{update.heading}</h2>
        <p className="mt-4 max-w-5xl text-base leading-8 text-neutral-700">{update.summary}</p>

        <div className="mt-7 grid gap-5 lg:grid-cols-2">
          <section className="rounded-[1.5rem] border border-neutral-200 bg-neutral-50 p-5">
            <h3 className="text-lg font-black text-neutral-950">{labels?.context || "Technical context"}</h3>
            <ul className="mt-4 grid gap-3 text-sm leading-7 text-neutral-700">
              {update.verifiedFacts.map((fact) => <li key={fact} className="rounded-xl bg-white p-4">{fact}</li>)}
            </ul>
          </section>

          <section className="rounded-[1.5rem] border border-amber-200 bg-amber-50 p-5">
            <h3 className="text-lg font-black text-amber-950">{labels?.limitations || update.limitationsTitle}</h3>
            <ul className="mt-4 grid gap-3 text-sm leading-7 text-amber-950/80">
              {update.evidenceLimits.map((limit) => <li key={limit} className="rounded-xl bg-white/80 p-4">{limit}</li>)}
            </ul>
          </section>
        </div>

        {update.related?.length ? (
          <nav aria-label={labels?.related || "Related pages"} className="mt-7">
            <h3 className="text-lg font-black text-neutral-950">{labels?.related || "Related TechniaHQRobot pages"}</h3>
            <div className="mt-3 flex flex-wrap gap-2">
              {update.related.map((item) => (
                <Link key={item.to} to={item.to} className="focus-ring rounded-full border border-neutral-300 bg-white px-4 py-2 text-sm font-black text-neutral-800 transition hover:border-blue-200 hover:text-blue-700">
                  {item.label}
                </Link>
              ))}
            </div>
          </nav>
        ) : null}

        <section className="mt-7 border-t border-neutral-200 pt-6">
          <h3 className="text-lg font-black text-neutral-950">{labels?.sources || "Sources"}</h3>
          <ul className="mt-4 grid gap-3 lg:grid-cols-2">
            {update.sources.map((source) => (
              <li key={source.url} className="rounded-xl border border-neutral-200 bg-neutral-50 p-4 text-sm leading-6 text-neutral-700">
                <a href={source.url} target="_blank" rel="noopener noreferrer" className="font-black text-neutral-950 underline decoration-blue-300 underline-offset-4 hover:text-blue-700">
                  {source.organization} {source.title}
                </a>
                <span className="mt-1 block text-xs text-neutral-500">{publicationLabels[source.published] || source.published}. {labels?.accessed || "Accessed"} {source.accessed}.</span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </section>
  );
}
